export * from "-!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SearchService.vue?vue&type=style&index=0&id=3b3b72b7&lang=scss&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/SearchService.vue?vue&type=style&index=0&id=3b3b72b7&lang=scss&scoped=true&
// module id = Nzh4
// module chunks = 0